import React from 'react';
export function Hero() {
  return <div className="flex-grow flex flex-col items-center justify-center relative z-10 px-4 text-center pb-20 pt-10" data-id="element-8">
      {/* Green Banner */}
      <div className="bg-[#5a9e3f] w-full max-w-4xl py-3 px-4 rounded-sm mb-10 shadow-lg" data-id="element-9">
        <h2 className="text-white text-2xl md:text-4xl font-bold uppercase tracking-wide" data-id="element-10">
          Now Accepting Applications
        </h2>
      </div>

      {/* Main Heading */}
      <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 drop-shadow-xl" data-id="element-11">
        High Paying Skilled Trade Jobs
      </h1>

      {/* Divider */}
      <div className="h-1.5 w-64 md:w-96 bg-[#5a9e3f] mb-8 shadow-sm" data-id="element-12"></div>

      {/* Subtext */}
      <p className="text-white text-lg md:text-2xl mb-12 max-w-3xl drop-shadow-md font-medium" data-id="element-13">
        Apply now for high-paying labor and technician jobs with travel and per
        diem
      </p>

      {/* CTA Button */}
      <button className="bg-[#5a9e3f] hover:bg-[#4a8233] text-white text-lg md:text-xl font-medium px-10 py-4 rounded transition-colors shadow-lg" data-id="element-14">
        Apply Now
      </button>
    </div>;
}